export default "__VITE_ASSET__CxkBvLoH__"